<template>
  <div class="relative overflow-x-auto">
    <table class="w-full min-w-[40rem] text-sm">
      <thead>
        <tr class="border-b border-slate-200 dark:border-slate-700">
          <th
            v-for="col in columns"
            :key="col.key"
            scope="col"
            class="table-th"
            :class="[alignClass(col), col.headerClass]"
            :aria-sort="ariaSort(col)"
          >
            <button v-if="col.sortable" type="button" class="inline-flex items-center gap-1 uppercase tracking-wider hover:text-slate-900 dark:hover:text-slate-100" @click="$emit('sort', col.sortable === true ? col.key : col.sortable)">
              {{ col.label }}
              <AppIcon v-if="sortDirection(col)" :name="sortDirection(col) === 'asc' ? 'arrow-up' : 'arrow-down'" :size="12" />
            </button>
            <template v-else>{{ col.label }}</template>
          </th>
        </tr>
      </thead>
      <tbody :class="{ 'opacity-50 transition-opacity': loading && rows.length }">
        <template v-if="loading && !rows.length">
          <tr v-for="n in 5" :key="`s${n}`" class="border-b border-slate-100 dark:border-slate-700">
            <td v-for="col in columns" :key="col.key" class="table-td"><div class="h-4 animate-pulse rounded bg-slate-100 dark:bg-slate-700" /></td>
          </tr>
        </template>
        <template v-else>
          <tr
            v-for="row in rows"
            :key="row[rowKey]"
            class="border-b border-slate-100 transition-colors hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-700/50"
            :class="{ 'cursor-pointer': clickable }"
            @click="clickable && $emit('row-click', row)"
          >
            <td v-for="col in columns" :key="col.key" class="table-td" :class="[alignClass(col), col.class]">
              <slot :name="`cell-${col.key}`" :row="row" :value="row[col.key]">
                {{ col.format ? col.format(row) : display(row[col.key]) }}
              </slot>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <slot v-if="!loading && !rows.length" name="empty" />
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'DataTable',
  components: { AppIcon },
  props: {
    columns: { type: Array, required: true },
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    sort: { type: String, default: '' },
    rowKey: { type: String, default: 'id' },
    clickable: { type: Boolean, default: false }
  },
  emits: ['sort', 'row-click'],
  methods: {
    alignClass(col) {
      return col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'
    },
    sortKey(col) {
      return col.sortable === true ? col.key : col.sortable
    },
    sortDirection(col) {
      if (!col.sortable) return null
      const key = this.sortKey(col)
      if (this.sort === key) return 'asc'
      if (this.sort === `-${key}`) return 'desc'
      return null
    },
    ariaSort(col) {
      const d = this.sortDirection(col)
      return d ? (d === 'asc' ? 'ascending' : 'descending') : undefined
    },
    display(value) {
      return value === null || value === undefined || value === '' ? '—' : value
    }
  }
}
</script>
